export const GET_PERSON_EXECUTIONS_REQUEST = "GET_PERSON_EXECUTIONS_REQUEST";
export const GET_PERSON_EXECUTIONS_REQUEST_SUCCEEDED = "GET_PERSON_EXECUTIONS_REQUEST_SUCCEEDED";
export const GET_PERSON_EXECUTIONS_REQUEST_FAILED = "GET_PERSON_EXECUTIONS_REQUEST_FAILED";
